import { alpha } from '@mui/material';
import { blue20 } from '../../../colors/blue';
import { gray20, gray75 } from '../../../colors/gray';
import { MuiListItemButton } from './MuiListItemButton';
var topNavItemStyles = MuiListItemButton.customOverrides.topNavItem;
export var MuiAppBar = {
    styleOverrides: {
        colorPrimary: {
            backgroundColor: gray75,
            color: gray20,
        },
        root: {
            '& [data-component=action-group-container]': {
                // Action group button inside AppBar will have the same styles as topNavItem.
                button: topNavItemStyles,
                "& button[data-has-selected='true']": topNavItemStyles['&[class*=Mui-selected]'],
                "& button[data-has-selected='true']:hover": {
                    backgroundColor: alpha(blue20, 0.15),
                },
            },
        },
    },
};
